import React from 'react'
import BaseComponent from './BaseContainer'
import { graphql, compose, withApollo } from 'react-apollo'
import { Redirect } from 'react-router'
import RoleForm from '../components/form/Role'
import getRole from '../apollo/graphql/role/get'
import getRoles from '../apollo/graphql/role/getRoles'
import getPermissions from '../apollo/graphql/permission/getPermissions'
import createRole from '../apollo/graphql/role/create'
import deleteRole from '../apollo/graphql/role/delete'
import updateRole from '../apollo/graphql/role/update'

class RoleContainer extends BaseComponent {

  constructor(props) {
    super(props)

    const isNew = props.match.params.objId === 'new' || props.match.params.objId === undefined

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false }
      },
      redirect: false,
      obj: { id: null, name: '', description: '', permissions: [] }
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client.query({
        query: getRole,
        variables: { id: this.props.match.params.objId },
      }).then(({ data }) => {
        if (getRole.error) {
          this.setState({
            status: {
              ...this.state.status,
              error: true, message: getRole.error.message
            }
          })
        }
        let newState = {
          ...this.state,
          obj: {...data.getRole}
        }
        newState.obj.permissions = [ ...data.getRole.permissions ]
        newState.status.loading = false
        this.setState(newState)
      })
    } else {
      this.setState({
        ...this.status,
        status: {
          ...this.state.status,
          loading: false
        }
      })
    }
  }

  handleChange(event, permission) {
    let newState = {
      obj: {
        ...this.state.obj
      }
    }
    if (permission) {
      //permission
      let isInPermissions = false
      let i = 0
      for (let _permission of newState.obj.permissions) {
        if (_permission.id === permission.id) {
          isInPermissions = true
          newState.obj.permissions.splice(i, 1)
          break
        }
        i++
      }
      if (!isInPermissions) { newState.obj.permissions.push(permission) }
    } else {
      //simple data
      newState.obj[event.target.id] = event.target.value
    }
    this.setState(newState)
  }

  handleSubmit(event) {
    event.preventDefault()
    this.setState({
      status: {
        ...this.state.status,
        loading: true
      }
    })
    let obj = {...this.state.obj}
    obj.permissions = obj.permissions.map(permission => { return { id: permission.id }})
    this.state.status.isNew ?
      this.props.createRole({
        variables: {
          ...obj
        }
      }).then((data) => {this.setState({redirect: true})}).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true,
            isNew: true
          }
        })
      }) :
      this.props.updateRole({
        variables: {
          ...obj
        }
      }).then((data) => {
        this.setState({
          obj: data.data.updateRole,
          redirect: true
        })
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
  }

  handleDelete(event, data) {
    event.preventDefault()
    let newState = {
      status: {
        ...this.state.status,
        deletion: {}
      }
    }
    switch (data.confirm) {
    case true:
      newState.status.deletion.confirm = true
      break
    case null:
      newState.status.deletion.confirm = false
      break
    case false:
      newState.status.deletion.confirm = false
      this.props.deleteRole({variables: {id: this.state.obj.id}}).then(
        this.props.history.push('/roles')
      ).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
      break
    default:
      break
    }
    this.setState(newState)
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/roles'/>
    }
    if (this.state.status.loading) {
      return <div>Chargement</div>
    }

    return <RoleForm
      obj={this.state.obj}
      status={this.state.status}
      permissions={this.props.permissions}
      onChange={this.handleChange}
      onSubmit={this.handleSubmit}
      onDelete={this.handleDelete} />
  }
}

const RoleContainerEnhanced = compose(
  graphql(getPermissions, { name: 'permissions' }),
  graphql(updateRole, { name: 'updateRole' }),
  graphql(createRole, { name: 'createRole' }),
  graphql(deleteRole, {
    name: 'deleteRole',
    options: {
      update: (proxy, { data }) => {
        const roles = proxy.readQuery({ query: getRoles })
        roles.getRoles = roles.getRoles.filter(obj => obj.id !== data.deleteRole.id)
        proxy.writeQuery({ query: getRoles, data: roles })
      }
    }
  })
)(RoleContainer)

export default withApollo(RoleContainerEnhanced)



// WEBPACK FOOTER //
// ./src/containers/RoleContainer.js